import React from "react";
import AuthAmbientLayers from "./AuthAmbientLayers";
import AuthShellNavbar from "./AuthShellNavbar";
import { useAuthPageChrome } from "./useAuthPageChrome";
import "./AuthPages.scss";

type AuthCardShellProps = {
  children: React.ReactNode;
  /** Green ambient layers behind the card (forgot / reset). */
  ambient?: boolean;
};

/** Forgot / reset / verify / SSO chrome: green page + card + navbar. */
const AuthCardShell: React.FC<AuthCardShellProps> = ({
  children,
  ambient = false,
}) => {
  const { triggerZoomOut, zoom, zoomProps, anim, pageClassName } =
    useAuthPageChrome();

  return (
    <>
      <div
        className={pageClassName(
          ambient && "auth-page--ambient",
          "auth-page--card",
        )}
        style={zoomProps}
      >
        {ambient && <AuthAmbientLayers />}
        <AuthShellNavbar anim={anim} triggerZoomOut={triggerZoomOut} />
        <div className="auth-card">{children}</div>
      </div>
      {zoom && <div className="auth-zoom-bg" />}
    </>
  );
};

export default AuthCardShell;
